import { forwardRef } from 'react';
import { CSSProperties } from 'styled-components';

import { Text } from '~src/components/Typography';
import { CustomerFinancingProvider } from '~src/model';
import { getDisclaimer } from '~src/pages/Estimate/util';

type LoanDisclaimerProps = { financingProvider?: CustomerFinancingProvider; style?: CSSProperties };

export const LoanDisclaimer = forwardRef<HTMLDivElement, LoanDisclaimerProps>(function LoanDisclaimer(
  { financingProvider, style }: LoanDisclaimerProps,
  ref
) {
  const disclaimer = getDisclaimer(financingProvider);

  return (
    <div style={style} ref={ref}>
      <Text
        color='light'
        style={{
          fontSize: '10px',
          lineHeight: '11px',
        }}
      >
        *{disclaimer}
      </Text>
    </div>
  );
});
